jQuery(document).ready(function(){
	var url = window.location.href;
		var urlparth = url.split("/");
		var domain = window.location.origin;
		urlparth.shift();
		urlparth.shift();
		urlparth.pop();
	console.log(urlparth);
		
	var breadcrumbs = [];
	var buffer = domain;
	for(var i = 0; i < urlparth.length; i++){
		var name = (i == 0) ? "home": urlparth[i]
		var position = i + 1;
		var item = {"@type":"ListItem", "position": position, "item":{  "@id": buffer, "name": name}};
		
		buffer = buffer + "/" + urlparth[i];
		breadcrumbs.push(item);
	}
	console.log(breadcrumbs)
	
	var headline = document.getElementsByClassName("sdHeadline");

	var name = "Boxspring.nl";
	var facebook = "https://www.facebook.com/BoxspringNL";
	var linkedin = "https://www.linkedin.com/company/boxspring-nl-uw-bed-bv";
	var socialmedia = [facebook, linkedin];
	var img = "https://cdn.shopify.com/s/files/1/0571/8723/8086/t/21/assets/logo.svg?v=105313956648067648401647259124";

	var page = document.createElement('script');
	page.type = 'application/ld+json';
	page.type = 'application/ld+json';
	page.text = JSON.stringify({ 
		"@context" : "http://schema.org",
		"@type":"WebPage",
		"description": getMeta('description') ,
		"mainEntityOfPage": url,
		"name": headline,
		"@id": url,
		"author":{ 
			"@type":"Organization",
			 "sameAs":socialmedia,
			"name": name,
			"url": domain,
			"logo":{ 
				"@type":"ImageObject",
				"url": img,
				"height":600,
				"width":600
			}
		},
		"headline": headline,
		"inLanguage":"nl",
		"publisher":{ 
			"@type":"Organization",
			 "sameAs":socialmedia,
			"name": name,
			"url": domain,
			"logo":{ 
				"@type":"ImageObject",
				"url": img,
				"height":600,
				"width":600
			}
		},
		"copyrightHolder":{ 
			"@type":"Organization",
			 "sameAs":socialmedia,
			"name": name,
			"url": domain,
			"logo":{ 
				"@type":"ImageObject",
				"url": img,
				"height":600,
				"width":600
			}
		}
	});

	var breadcrumb = document.createElement('script');
	breadcrumb.type = 'application/ld+json';
	breadcrumb.text = JSON.stringify({ 
	  "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": breadcrumbs
	});
	
	
	
	var business = document.createElement('script');
	business.type = 'application/ld+json';
	business.text = JSON.stringify({ 
		"@context" : "http://schema.org",
		"@type" : "LocalBusiness",
		"name" : name,
		"image" : img,
		"telephone" : "088-33 22 333",
		"email" : "shop@boxspring.nl",
		"address" : {
			"@type" : "PostalAddress",
			"streetAddress" : "Luxemburgstraat 5",
			"addressLocality" : "Kaatsheuvel",
			"addressCountry" : "Nederland",
			"postalCode" : "5171 PK"
		},
		"priceRange": "€ - €€€",
		"openingHours": [
			"Ma 09:00-17:00",
			"Tu 09:00-17:00",
			"We 09:00-17:00",
			"Th 09:00-17:00",
			"Fr 09:00-16:00"
		],
		"aggregateRating": {
			"@type": "AggregateRating",
			"ratingValue": "4,9",
			"reviewCount": "14"
		  },
	   "geo": {
			"@type": "GeoCoordinates",
			"latitude": 51.666920,
			"longitude": 5.024080
		   },
		"url" : domain,
		"@id": url

	});

	document.querySelector('head').appendChild(breadcrumb);
	document.querySelector('head').appendChild(business);
	document.querySelector('head').appendChild(page);

});

function getMeta(metaName) {
	const metas = document.getElementsByTagName('meta');

	for (let i = 0; i < metas.length; i++) {
		if (metas[i].getAttribute('name') === metaName) {
			return metas[i].getAttribute('content');
		}
	}

	return '';
}